import { Box, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import { happyCustomerInfo } from "../../constants/happyCustomerData";
import MemoizedVehicleBadges from "../../modules/Home/HomePageVehicleThumbnail/vehicleBatch";
import { MemoizedSuperUserProfile } from "./SuperUserProfile";

const CustomHappyCustomers = styled(Box)(({ theme }) => ({
  ".cutomerList": {
    overflowX: "auto",
    display: "flex",
    overflowY: "hidden",
    flexDirection: "row",
    whiteSpace: "nowrap",
    margin: "10px 4px 10px 4px",
    "::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

const HappyCustomers = ({ customerId, isHideTestimonialContent = false }) => {
  const [type, setType] = useState(happyCustomerInfo[customerId ?? 0]?.type);
  const [customerData, setVehicleData] = useState(
    happyCustomerInfo[customerId ?? 0]
  );

  const handleSelection = (res) => {
    setVehicleData(res);
    setType(res?.type);
  };

  return (
    <CustomHappyCustomers>
      <Box id="customer-thumbnail-box">
        <Box className="cutomerList">
          {Array.isArray(happyCustomerInfo) && happyCustomerInfo?.map((res, key) => {
            return (
              <Box
                textAlign={"center"}
                key={key}
                onClick={() => {
                  handleSelection(res);
                }}
              >
                <MemoizedVehicleBadges
                  selectedType={type}
                  type={res?.type}
                  thumbnail={res?.thumbnail}
                />
                <Typography
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  {res?.name}
                </Typography>
              </Box>
            );
          })}
        </Box>
        <Box>
          <MemoizedSuperUserProfile data={customerData} isHideTestimonialContent={isHideTestimonialContent}/>
        </Box>
      </Box>
    </CustomHappyCustomers>
  );
};

export const MemoizedHappyCustomers = React.memo(HappyCustomers);
